import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { contentBankApi, postsApi } from "../../../utils";
import { throwApiError } from "../../lms-shared/store/error-handling-actions";
import * as PathRouter from '../../../models/PathRoute'
import classes from './DirectLessonViewer.module.css'
import LessonViewerTabs from "../../lms-shared/LessonViewer/Tabs/LessonViewerTabs";

const DirectLessonViewer = () => {

    const [data, setData] = useState()
    const dispatch = useDispatch();
    const { postId } = useParams()
    const { texts, lang } = useSelector(state => state.translate);
    const homeUrl = useSelector((state) => state.application.homeUrl);

    useEffect(() => {
        if (lang) {
            if (window.location.pathname.includes(PathRouter.CBLESSON)) {
                contentBankApi.contentBankFilterIdPost(postId, callback);
            }
            else {
                postsApi.postsFilterIdPost(postId, callback);
            }
        }
    }, [lang])

    function handleOpenProject() {
        window.location.href = `${window.location.origin}${homeUrl}/${PathRouter.LESSONPROJECT}/${postId}`
    }

    const callback = (error, resdata, response) => {
        if (error) {
            dispatch(throwApiError({ userMessage: texts.projectsFilterIdError, error: error, statusCode: response?.statusCode, message: "projectsFilterIdPost " + error.message, level: 2, component: "Project", line: 58 }))
        } else {
            if (resdata) {
                let contentData = JSON.parse(resdata.contentData)
                setData({

                    id: resdata.id,
                    name: resdata.name,
                    description: resdata.description,
                    keywords: null,
                    materialContentType: contentData?.MaterialContentTypeId,
                    materialContentPath: `${resdata.url}/${contentData?.MaterialUrl}`,
                    planContentType: contentData?.PlanContentTypeId,
                    planContentPath: `${resdata.url}/${contentData?.PlanUrl}`,
                    visible: true,
                    ide: {
                        id: contentData?.Ide?.Id,
                        name: contentData?.Ide?.Name,
                        description: null,
                        url: contentData?.Ide?.Url,
                        integrated: contentData?.Ide?.Integrated,
                        additionalConfiguration: contentData?.Ide?.AdditionalConfiguration,
                    },
                    teacherFullName: resdata.user?.firstName + ' ' + resdata.user?.lastName,
                    assessment: contentData.FinalAssessment ? {
                        id: null,
                        name: contentData?.FinalAssessment?.Name,
                        description: contentData?.FinalAssessment?.Description,
                        dueDate: null,
                        contentData: JSON.stringify(contentData?.FinalAssessment?.ContentData),
                        baseProject: null,
                        sourceType: contentData?.FinalAssessment?.SourceTypeId,
                        activityType: 0,
                        filesBaseUrl: `${resdata.url}/${contentData?.FinalAssessment?.BaseUrl}`,
                        submission: {
                            project: {
                                name: contentData?.FinalAssessment?.ContentData?.BaseProject?.Name,
                                url: `${resdata.url}/${contentData?.FinalAssessment?.BaseUrl}/${contentData?.FinalAssessment?.ContentData?.BaseProject?.Url}`
                            }
                        },
                        subAssessments: []
                    } : null

                })
            }
        }
    }

    return (
        <div className={classes.DirectLessonViewer}>
            <LessonViewerTabs teacherMode={true} data={data} setData={setData} onlyView={true} handleOpenProject={handleOpenProject}></LessonViewerTabs>
            <div className={classes.IdeRunnerPopupContainer}></div>
        </div >
    )
}

export default DirectLessonViewer;